/**
 * Hand bytes to the browser as a download and forget them.
 *
 * An object URL, a click, revoked in the same turn. Nothing navigates, nothing
 * is stored, and no personal data reaches the address bar -- the blob URL is
 * opaque and is gone before the next frame. `download` is what makes this an
 * attachment rather than a navigation: the contents never render in the tab.
 */
export function saveAsAttachment(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
